import { useRef } from 'react';
import { riderWork } from '../../api/riderWork';
import { useLiveLocation } from '../../hooks/useLiveLocation';
import { getDriverSession } from '../../lib/driverSession';
import { useJourneyPings } from './useJourneyPings';

/**
 * The carried job's positions on the job's own screens (the job, the pickup,
 * the navigation, the cash, the rating). Those screens sit outside
 * `DriverLayout` (`DriverAuthGate` holds them), so `DriverOffersProvider` and
 * its journey hook are not mounted there: on the emulator, 2 Oct 2026, the
 * rider carried a parcel with nothing telling the native recorder which job it
 * was and nothing pinging, and the client's map had no rider for the whole job.
 * Mounted by `DriverAuthGate`, never beside the provider: the two route sets do
 * not meet, so there is one journey hook at a time.
 */
export default function DriverJourneyPositions({ work = riderWork, native }) {
  const driverId = getDriverSession()?.id || null;
  const live = useLiveLocation({ mapThrottleMs: 12000, movePublishMeters: 80 });
  const liveRef = useRef(live);
  liveRef.current = live;
  useJourneyPings({ driverId, liveRef, located: Boolean(live.located), work, ...(native ? { native } : {}) });

  return null;
}
